import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CeRequestOptions } from "../../request-header/request-header.component";
import { asEnumerable } from "linq-es2015";

@Component({
  selector: "app-harvest-instructions",
  templateUrl: "./harvest-instructions.component.html"
})
export class HarvestInstructionsComponent implements OnInit {
  @Input() ceRequestOptions: CeRequestOptions;
  @Input() harvestInstructions: FormGroup;

  public get minimumSeedsToReturn() {
    return this.harvestInstructions.get('minimumSeedsToReturn');
  }

  public get forAdvancement() {
    return this.harvestInstructions.get('forAdvancement');
  }

  public get haploidInduction() {
    return this.harvestInstructions.get('haploidInduction');
  }

  public get manyToOne() {
    return this.harvestInstructions.get('manyToOne');
  }

  public get uniquePedigree() {
    return this.harvestInstructions.get('uniquePedigree');
  }

  public get showHarvestFollowupOptions(): boolean {
    return this.forAdvancement && <boolean> this.forAdvancement.value === true;
  }

  constructor() {}

  ngOnInit(){
    this.forAdvancement.valueChanges.subscribe((isForAdvancement: boolean) => {
      if (isForAdvancement === false) {
        this.haploidInduction.setValue(false);
        this.manyToOne.setValue(false);
        this.uniquePedigree.setValue(false);
      }
      
      this.haploidInduction.updateValueAndValidity();
      this.manyToOne.updateValueAndValidity();
      this.uniquePedigree.updateValueAndValidity();
    });
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/harvest-instructions/harvest-instructions.component.ts